// extracted by mini-css-extract-plugin
export default {"container":"time_container__ssF56","timeContainer":"time_timeContainer__xKpGT","dateContainer":"time_dateContainer__EvTlH","box":"time_box__29pfN"};